import * as React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemButton, ListItemText, Divider, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import usePurchaseWorkflow from '../../hooks/usePurchaseWorkflow';

const PURCHASE_MENU_STAGE = {
    '/purchaserequest': 'PR',
    '/purchaseorder': 'PO',
    '/grn': 'PD',
    '/purchaseinvoice': 'PI'
};
const PURCHASE_STAGES = ['PR', 'PO', 'PD', 'PI'];

export default function BasicMenu() {

    // const dispatch = useDispatch()
    const navigate = useNavigate()

    const { navbarMenu } = useSelector((state) => state.menus)
    const { startStage } = usePurchaseWorkflow();

    const allowedMenus = React.useMemo(
        () => (Array.isArray(navbarMenu) ? navbarMenu : [])
            .map((headMenu) => ({
                ...headMenu,
                ArrSubMenu: (Array.isArray(headMenu?.ArrSubMenu) ? headMenu.ArrSubMenu : [])
                    .filter((subMenu) => {
                        const path = String(subMenu?.menuURL || '').trim().toLowerCase();
                        if (!path) return false;
                        const stage = PURCHASE_MENU_STAGE[path];
                        return !stage || PURCHASE_STAGES.indexOf(stage) >= PURCHASE_STAGES.indexOf(startStage);
                    })
            }))
            .filter((headMenu) => headMenu.ArrSubMenu.length > 0),
        [navbarMenu, startStage]
    );

    return (
        <>
            {allowedMenus.map((hm, index) => (
                <Accordion key={index} sx={{ bgcolor: 'var(--web-theme-sidebar-bg, #FFFFFF)', color: 'var(--web-theme-sidebar-text, #1F2937)' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        sx={{ minHeight: 32, bgcolor: 'var(--web-theme-sidebar-bg, #FFFFFF)', color: 'var(--web-theme-sidebar-text, #1F2937)', '& .MuiAccordionSummary-content': { margin: 1 } }}
                    >
                        <Typography>{hm.headMenu}</Typography>
                    </AccordionSummary>
                    {hm.ArrSubMenu.map((sm, subIndex) => (
                        <AccordionDetails key={`${index}-${subIndex}`} sx={{ padding: '4px 8px' }}>
                            <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'var(--web-theme-sidebar-bg, #FFFFFF)', color: 'var(--web-theme-sidebar-text, #1F2937)' }}>
                                <nav aria-label="main mailbox folders">
                                    <List sx={{ p: 0, m: 0 }}>
                                        <Divider sx={{ bgcolor: 'black' }} />
                                        <Divider sx={{ bgcolor: 'yellow' }} />
                                        <Divider sx={{ bgcolor: 'black' }} />
                                        <ListItem sx={{ p: 0, m: 0 }}>
                                            <ListItemButton sx={{ py: 0.5, px: 1, color: 'var(--web-theme-sidebar-text, #1F2937)', borderRadius: 'var(--web-theme-radius, 4px)', '&:hover': { bgcolor: 'var(--web-theme-sidebar-active, #FFF3BF)' } }} onClick={() => navigate(`${sm.menuURL}`)}>
                                                <ListItemText primaryTypographyProps={{ fontSize: 13 }} primary={`${sm.subMenu}`} />
                                            </ListItemButton>
                                        </ListItem>
                                        <Divider sx={{ bgcolor: 'black' }} />
                                        <Divider sx={{ bgcolor: 'yellow' }} />
                                        <Divider sx={{ bgcolor: 'black' }} />
                                    </List>
                                </nav>
                            </Box>
                        </AccordionDetails>
                    ))}
                </Accordion>
            ))}
        </>
    );
}





